import React, { Component } from "react";
import { connect } from "react-redux";
import { destroyDarkPattern, removeDarkPattern } from "../../actions/darkPatterns.js";
import { incrementClickSequence, resetClickSequence } from "../../actions/clickSequence.js";
import { createExplosion } from "../../actions/explosions.js";
import { addScore } from "../../actions/actionCreators.js";
import ClickerPattern from "./ClickerPattern.js";
import Explosion from "../Explosion.js";

const mapStateToProps = state => {
	return {
		patterns: state.patterns,
		explosions: state.explosions,
		clickSequence: state.clickSequence,
		isMobile: state.game.mobile
	};
};

const mapDispatchToProps = dispatch => {
	return {
		patternClicked: (id, e, z, o, v, m, isMobile) => {
			dispatch(destroyDarkPattern(id));
			dispatch(incrementClickSequence())
			if( e && z ){
				if (isMobile) {
					if (e.touches === undefined) return;
					var touch = e.touches[0];
					if (touch === undefined) return;
					dispatch(createExplosion({
						x: touch.pageX - o.x,
						y: touch.pageY - o.y,
						value: v,
						z, id
					}));
				} else {
					dispatch(createExplosion({
						x: e.clientX - o.x,
						y: e.clientY - o.y,
						value: v,
						z, id
					}));
				}
				// console.log(v, m);
				// if (m === 0) m =1;
				dispatch(addScore("popover", v * m));
			}
		},
		removeDarkPattern: id => {
			dispatch(removeDarkPattern(id));
			dispatch(resetClickSequence());
		}
	};
};

class PatternDisplay extends Component {

	render() {
		const props = this.props;
		return (
			<div ref="flyingads" className="flyingads">
				{props.explosions.map((el, i) => {
					return (
						<Explosion
							width={200 * el.z}
							height={200 * el.z}
							score={el.value}
							top={el.y}
							left={el.x}
							key={el.id}
							id={el.id}
						/>
					);
				})}
				{props.patterns.map((el, i) => {
					return (
						<ClickerPattern
							image={el.image}
							animationDuration={el.animationDuration}
							vTranslate={el.vTranslate}
							vRotation={el.vRotation}
							lane={el.lane}
							patternClicked={(e, progress) => {
								if (progress === undefined) {
									// remove this thing, no audio or fx
									this.props.removeDarkPattern(el.id);
									return;
								}
								if(!this.refs.flyingads) return;
								const rect = this.refs.flyingads.getBoundingClientRect();
								const multiplier = Math.floor( this.props.clickSequence / 10 ) + 1;
								const screenoffset = {
									x : rect.left + window.scrollX,
									y : rect.top + window.scrollY
								}
								this.props.patternClicked(el.id, e, progress, screenoffset, el.value, multiplier, this.props.isMobile);
							}}
							bg={el.bg}
							key={el.id}
							id={el.id}
							z={el.z}
							// imageDead={el.imageDead}
						/>
					);
				})}
			</div>
		);
	}
}
const PatternManager = connect(mapStateToProps, mapDispatchToProps)(PatternDisplay);

export default PatternManager;



// WEBPACK FOOTER //
// ./src/components/darkpatterns/PatternManager.js